// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-spinner-ripple{display:inline-block;position:relative}.v5-spinner-ripple div{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);border:.08rem solid #ff552e;opacity:1;border-radius:50%;box-sizing:border-box;animation:v5-spinner-ripple 1.2s cubic-bezier(0,.2,.8,1) infinite}.v5-spinner-ripple div:nth-child(2){animation-delay:-.5s}@keyframes v5-spinner-ripple{0%{width:0;height:0;opacity:1}to{width:100%;height:100%;opacity:0}}", ""]);
// Exports
module.exports = exports;
